var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTeacher = function SvgTeacher(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.5C10.2091 9.5 12 7.70914 12 5.5C12 3.29086 10.2091 1.5 8 1.5C5.79086 1.5 4 3.29086 4 5.5C4 7.70914 5.79086 9.5 8 9.5Z",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16.5C1.50039 13.6804 3.31754 11.1821 6 10.3134L8 12L10 10.3134C12.6831 11.1814 14.5008 13.68 14.5007 16.5",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7693 11.204C11.2287 10.8181 10.632 10.5177 10 10.3134L8 12L11 14L11.7693 11.204Z",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 12L5.99999 10.3134C5.36831 10.5179 4.7718 10.8183 4.23132 11.204L4.99999 14L7.99999 12Z",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 6.5C7.05228 6.5 7.5 6.05228 7.5 5.5C7.5 4.94772 7.05228 4.5 6.5 4.5C5.94772 4.5 5.5 4.94772 5.5 5.5C5.5 6.05228 5.94772 6.5 6.5 6.5Z",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 6.5C10.0523 6.5 10.5 6.05228 10.5 5.5C10.5 4.94772 10.0523 4.5 9.5 4.5C8.94772 4.5 8.5 4.94772 8.5 5.5C8.5 6.05228 8.94772 6.5 9.5 6.5Z",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5H5.5",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.5H13",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5V12",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTeacher);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";